export const menu = {
    label: 'Registro de Consultorias',
    icon: 'handshake',
    to: '/utilidades/consultorias',
    rules: ['UTIL-CONSULTORIAS-00'],
};

export default menu
